export const WS_RECONNECT_ENTER_ROOM_TIMEOUT = [5 * 1000, 15 * 1000, 20 * 1000] // ws重连后，重新进入房间的重试间隔，最多自动尝试三次
export const WS_RECOMMECT_TIMEOUT = [5 * 1000, 5 * 1000, 5 * 1000, 60 * 1000, 2 * 60 * 1000, 5 * 60 * 1000] // ws重连间隔